import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"

import app from "./app"

export const VUEX_STORAGE_KEY = "tuango_contest"

Vue.use(Vuex)

const persistedMutations = [
  "setIsContestClosed",
  "setSelectedDestination",
  "setUTMs",
  "switchLang"
]
const vuexLocal = new VuexPersistence({
  key: VUEX_STORAGE_KEY,
  storage: window.sessionStorage,
  filter: mutation =>
    persistedMutations.some(str => mutation.type.includes(str)),
  reducer: state => {
    return { app: state.app }
  }
})

const store = new Vuex.Store({
  modules: {
    app
  },
  actions: {
    resetState({ commit }) {
      commit("app/resetState")
    }
  },
  plugins: [vuexLocal.plugin]
})

export default store
